import React from 'react';
import PropTypes from 'prop-types';
import { imageSrc, imageSrcSet } from 'utils/images';

import './style.css';

const ImageProject = ({ title, url }) => {
    const fallbackSize = { width: 640, height: 360 };
    const imgSizes = [
        {
            width: 640,
            height: 360
        },
        {
            width: 320,
            height: 180
        }
    ];
    const sizes = `
        (min-width: 1200px) 600px,
        (min-width: 992px) 50vw,
        100vw
    `;

    let placeholder = title === 'Image title' ? true : false;
    let fallback = imageSrc(url, fallbackSize, placeholder);
    let srcDef = imageSrcSet(url, imgSizes, placeholder);

    return (
        <div className="ImageProject">
            <img alt={title} src={fallback} srcSet={srcDef} sizes={sizes} />
        </div>
    );
};

ImageProject.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string
};

ImageProject.defaultProps = {
    title: 'Image title',
    url: 'https://picsum.photos'
};

export default ImageProject;



// WEBPACK FOOTER //
// ./src/components/atoms/imageProject/index.js